import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  return request({
    url: '/system/auth/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: { username, password, code, uuid }
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/system/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 刷新方法
export function refreshToken() {
  return request({
    url: '/system/auth/refresh',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/system/auth/logout',
    method: 'delete'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 发送注册验证码
export function sendRegisterCode(email) {
  return request({
    url: '/system/publicView/sendRegisterCode',
    headers: {
      isToken: false
    },
    method: 'post',
    data: { email }
  })
}

// 租户注册
export function tenantRegister(data) {
  return request({
    url: '/system/publicView/tenantRegister',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}